import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Param } from '../../../../../../shared/types/param';

export const useSubmotiveRegisterHistory = (submotive4?: Param) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = submotive4 || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [submotive4]);

    return {
        formik,
    };
};
